/**
 * TypingIndicator.jsx — "CAI is thinking…" Animation
 *
 * Shows animated bouncing dots while waiting for the backend response.
 * Appears immediately after the user sends a message.
 */

import React from 'react';
import { Bot } from 'lucide-react';
import './TypingIndicator.css';

export default function TypingIndicator() {
  return (
    <div className="typing-row" role="status" aria-label="Querely is processing your query">
      {/* AI Avatar */}
      <div className="typing-avatar" aria-hidden="true">
        <Bot size={16} />
      </div>

      {/* Bubble with animated dots */}
      <div className="typing-bubble">
        <span className="typing-dot" style={{ animationDelay: '0ms'   }} />
        <span className="typing-dot" style={{ animationDelay: '160ms' }} />
        <span className="typing-dot" style={{ animationDelay: '320ms' }} />
        <span className="typing-label">Processing SAP query…</span>
      </div>
    </div>
  );
}
